import { SxProps } from '@mui/material';

export const noteIconBoxSx: SxProps = {
  width: 62,
  height: 62,
  borderRadius: 3,
  bgcolor: 'common.white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const noteTitleSx: SxProps = {
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '20px',
  color: 'custom.surfaceDark',
  flex: 1,
  mr: 2,
};

export const noteTimestampSx: SxProps = {
  fontWeight: 400,
  fontSize: 12,
  lineHeight: 1.2,
  letterSpacing: '-0.24px',
  color: 'custom.textSecondaryNew',
  whiteSpace: 'nowrap',
};

export const noteTextSx: SxProps = {
  fontWeight: 400,
  fontSize: 14,
  lineHeight: 1.4,
  letterSpacing: '-0.14px',
  color: 'custom.surfaceDark',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
};
